/** 读取配置文件中的版本号*/
import pkg from '../package.json';
const version = pkg.version;
//import { version } from '../package.json';

/** 全局配置 */
import { config } from './config';

import * as utils from './utils';

const quick = {
  config,
  version,
  ...utils,
};

/** 自动聚焦 */
//const focus
/**
 * 引入组件初始化安装
 * @param {*} app
 * @param {*} opts
 */
const install = (app, opts = {}) => {
  if (install.installed) return;

  // console.log('install', 'quick.lib');

  // console.log('install.$quick', 'quick.lib');

  let _resp = `version: ${version}`;
  if (opts.init) {
    quick.init();
    _resp += ' init';
  }

  // 是否全局挂载
  if (opts.global) {
    if (app.config) {
      /** vue 3.x 全局绑定quick 调用 */
      app.config.globalProperties.$quick = quick;

      _resp += ' $quick vue3.x ';
    } else {
      // vue 2.x 绑定全局调用
      app.prototype.$quick = quick;
      _resp += ' $quick vue2.x ';
    }
  }

  // 调试日志
  if (opts.log) {
    //调试日志输出
    //  quick.log.print(_resp, 'quick.lib');
    console.log(_resp, 'quick.lib');
    //print(process.env.VERSION);
  }

  // 绑定全局调用
  //app.prototype.$quick = quick;

  // // 全局使用 v-focus
  // app.directives('focus', {
  //   bind: function (el) {},
  //   inserted: function (el) {
  //     // 指令的定义
  //     el.focus();
  //   },
  //   updated(el) {
  //     //当v-model跟新的时候，就会执行这个函数  这个函数会执行多次
  //   },
  // });
};

// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue);
// }

// 导出组件方法
export default {
  install,
};

export { config, version };
export * from './utils';

/** 内容转码 */
//export * from './utils/zip.js';
